import React from "react";
import { Button, Form, Modal } from "semantic-ui-react";
import _ from "lodash";
import { AVAIL_SCOPES } from "env.config";
import { store } from "services/state";
import { validateAppDetail } from "utils/function-utils";

const EditAppDetail = ({
  appFormData,
  openEditModal,
  setOpenEditModal,
  setAppFormData,
  appDetail,
  onSaveUpdateApp,
  ENVIDE,
}) => {
  const handleChangeAppName = (_e, data) =>
    setAppFormData({
      ...appFormData,
      appName: data.value,
      appNameValid: true,
    });
  const handleChangeScope = (_e, data) => {
    setAppFormData({
      ...appFormData,
      oauthScope: data.checked
        ? appFormData.oauthScope.concat(data.value)
        : appFormData.oauthScope.filter((item) => item !== data.value),
      oauthScopeValid: true,
    });
  };
  const handleCancelUpdate = () => {
    setOpenEditModal(false);
    setAppFormData({
      appName: appDetail.AppName,
      oauthScope: appDetail.OauthScope,
      appNameValid: true,
      oauthScopeValid: true,
    });
  };

  const getUsagePlanIdParams = () => {
    // only apiGateway api need to subscribe
    const apiList = store.apiList.apiGateway;
    const acceptableEnvideList = new Set();
    // app assigned scopes
    const scopeList = appFormData.oauthScope.map((scope) =>
      scope.replace(/^42QAPI\//, "")
    );
    // scopes map to envide
    for (let key in ENVIDE) {
      if (scopeList.includes(ENVIDE[key].scope)) {
        acceptableEnvideList.add(key);
      }
    }
    // envide map to related apis
    const acceptableApiList = apiList.filter((api) => {
      // const apiEnv = api.swaggerApiName.split("-")[0];
      let apiEnv = "";
      const swaggerApiName = api.swaggerApiName;
      if (new RegExp(`^MES16-.*`).test(swaggerApiName)) {
        apiEnv = swaggerApiName.split("-")[1];
      } else {
        apiEnv = swaggerApiName.split("-")[0];
      }
      return acceptableEnvideList.has(apiEnv);
    });
    // api map to usagePlanId
    const usagePlanIdList = Object.keys(
      _.groupBy(acceptableApiList, (api) => {
        return api.usagePlan.id;
      })
    );
    return usagePlanIdList;
  };

  const handleSaveUpdate = () => {
    const newAppFormData = validateAppDetail(appFormData);
    if (newAppFormData) {
      setAppFormData(newAppFormData);
      return;
    }
    setOpenEditModal(false);
    const addUsagePlanId = getUsagePlanIdParams();
    const { appName, oauthScope } = appFormData;
    const params = {
      operation: "updateApp",
      appName,
      clientId: appDetail.AppId,
      oauthScope,
      addUsagePlanId,
      userName: appDetail.UserName,
    };
    onSaveUpdateApp(params);
  };

  const getAppNameError = () => {
    const { appNameValid, appNameErrorMessage } = appFormData;
    if (appNameValid) {
      return false;
    } else {
      if (appNameErrorMessage) {
        return appNameErrorMessage;
      } else {
        return true;
      }
    }
  };

  return (
    <Modal
      closeIcon
      size="small"
      open={openEditModal}
      onClose={handleCancelUpdate}
    >
      <Modal.Header>Edit App</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field required>
            <label>App Name</label>
            <Form.Input
              error={getAppNameError()}
              defaultValue={appFormData.appName}
              onChange={handleChangeAppName}
            />
          </Form.Field>
          <Form.Field required>
            <label>Allowed Scopes</label>
            {AVAIL_SCOPES.map((item) => {
              return (
                <Form.Field key={item}>
                  <Form.Checkbox
                    error={!appFormData.oauthScopeValid}
                    label={item}
                    value={item}
                    defaultChecked={
                      appFormData.oauthScope &&
                      appFormData.oauthScope.includes(item)
                    }
                    onChange={handleChangeScope}
                  />
                </Form.Field>
              );
            })}
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCancelUpdate}>Cancel</Button>
        <Button type="submit" positive onClick={handleSaveUpdate}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
export { EditAppDetail };
